<template>
  <div class="row">
    <div class="col-md-12">
      <div class="logs">
        <template v-if="logs.length">
          <div
            v-for="(log, index) in logs"
            :key="index"
            class="wrapper-log"
          >
            <div class="topic">
              <strong>
                {{ log._topic }}
              </strong>
              <div class="actions">
                <button
                  v-if="hasRoleEdit"
                  @click="handleToggleStatus(index, log)"
                >
                  <i
                    :class="[{ 'text-success': log.status === 'done' }]"
                    class="fas fa-check"
                    style="font-size: 17px;"
                  />
                </button>
                <button
                  v-if="log.status === 'todo' && hasRoleEdit"
                  @click="handleEdit(index, log)"
                >
                  <i class="fas fa-pen"/>
                </button>
                <button
                  v-if="log.status === 'todo' && hasRoleDelete"
                  @click="handleDelete(index, log)"
                >
                  <i class="fas fa-trash"/>
                </button>
              </div>
            </div>
            <div
              v-if="log.description"
              class="description"
            >
              {{ log.description }}
            </div>
            <div
              v-if="log.schedule_date"
              class="schedule-date"
            >
              {{ $t('message.scheduledate') }}: {{ getDateTime(log.schedule_date) }}
              |
              {{ getFriendlyTime(log.schedule_date) }}
            </div>
          </div>
        </template>
        <template v-else>
          <div>-</div>
        </template>
      </div>
    </div>
    <div
      v-if="showCreateButton && hasRoleCreate"
      class="col-md-12 mt-2"
    >
      <button
        class="btn btn-light btn-create"
        @click="handleCreate"
      >
        + {{ createButtonText }}
      </button>
    </div>
  </div>
</template>

<script>
import userPermissionMixin from '@/mixins/userPermission'

export default {
  props: {
    logs: {
      type: Array,
      default: true,
    },
    showCreateButton: {
      type: Boolean,
      default: true,
    },
    createButtonText: {
      type: String,
      default: true,
    },
  },

  mixins: [userPermissionMixin],

  methods: {
    handleCreate() {
      this.$emit('onCreate')
    },
    handleToggleStatus(index, log) {
      this.$emit('onToggleStatus', index, log)
    },
    handleEdit(index, log) {
      this.$emit('onEdit', index, log)
    },
    handleDelete(index, log) {
      this.$emit('onDelete', index, log)
    },
  },
}
</script>

<style scoped>
.logs {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.wrapper-log {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.wrapper-log .topic {
  position: relative;
}
.wrapper-log .topic .actions {
  position: absolute;
  width: 150px;
  top: 0;
  right: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}
.wrapper-log .topic .actions button {
  background: none;
  border: none;
  outline: none;
  width: 24px;
  height: 24px;
  cursor: pointer;
  color: #D4D4D4;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* .wrapper-log .description {

}
.wrapper-log .schedule-date {

} */
</style>



// WEBPACK FOOTER //
// src/components/base/BaseSectionDocRefLog.vue